module.exports = __webpack_public_path__ + "static/activity-e62fa4b0dd698cf3b5a7267a9139e3da.png";